import axiosInstance from "../lib/axiosInstance";

export const fetchCartItems = async () => {
    return axiosInstance.get(`/api/student/cart/getCart`);
};


export const addToCart = async (payload) => {
    return axiosInstance.post("/api/student/cart/addToCart", payload);
};

export const couponCodeApi = async (payload) => {
    return axiosInstance.post("/api/student/cart/applyCoupon", payload);
};

export const removeFromCart = async (payload) => {
    return axiosInstance.post(`/api/student/cart/removeFromCart/${payload}`);
};
export const removeCouponApi = async () => {
    return axiosInstance.post("/api/student/cart/removeCoupon");
};